import { isPlantNewEwoFeatures } from 'src/utils/plantFeature';
import axios from 'src/utils/terotechDataservice';
function getEwo(id) {
  return axios.get('/docewo/items/' + id);
}
function getLanguage(language) {
  switch (language) {
    case 'en':
      return 'en-US';
    case 'it':
      return 'it-IT';
    case 'fr':
      return 'fr-FR';
    case 'de':
      return 'de-DE';
    default:
      return 'en-US';
  }
}
function getItemDetailsById(id, module, language) {
  if (module === 'EWO') {
    return axios.get(`/docewo/getEwoDetailsById/${id}`);
  }
  return axios.get(
    `/doctag/getTagDetailsById/${id}?lang=${getLanguage(language)}`
  );
}

function getMachineCode(id) {
  return axios.get('/docewo/machineCode/' + id);
}

function getMachineId(code) {
  return axios.get(`/docewo/machineId?code=${code}`);
}

function getEwoIntervention(id) {
  return axios.get('/docewo/interventionitems/' + id);
}

function getBreakdowns() {
  return axios.get('/docewo/breakdowns');
}

function getEwosOpen(idPlant, IdMach) {
  //return axios.get('docewo/itemsv2?filter=idPlant%3D' + idPlant + '%26idmachine%3D' + IdMach +'%26dateclosing%3Dnull%26statedoc%3E0'
  return axios.get(
    'docewo/openewos?filter=idPlant%3D' +
    idPlant +
    '%26idmachine%3D' +
    IdMach +
    '%26dateclosing%3Dnull%26statedoc%3E0'
  );
}

function postEwo(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.post('/docewo/items', data, options);
}
function postFile(id, files) {
  let formData = new FormData();
  files.forEach(file => {
    formData.append('file', file, file.name);
  });
  const options = {
    headers: { 'Content-Type': 'multipart/form-data' }
  };
  return axios.post(`/docewo/postFile?id=${id}`, formData, options);
}
function postEwoAttachments(id, files) {
  let formData = new FormData();
  for (var i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }
  const options = {
    headers: { 'Content-Type': 'multipart/form-data' }
  };
  return axios.post(`/docewo/postEwoAttachments?id=${id}`, formData, options);
}

// function putImageMac(id,files){
//   var formData = new FormData();
//   files.forEach((file) => {
//     formData.append("file",file);
//   });
//   const options = {
//     headers: {'Content-Type': 'multipart/form-data'}
//   };
//   return axios.post('/machine/image?id=' + id,formData,options);
// }

function updateOnHold(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.put('/doceworeporting/updateonhold', data, options);
}

function updateInCarico(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.put('/docewo/updateInCarico', data, options);
}

function postDuplicateItem(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.post('/machinestructure/duplicate', data, options);
}

function getGroup(IdMach) {
  //idmachine= 1 e level=1
  return axios.get(
    '/machinestructure/structureItemsByIdMachineOrIdFather?idMachine=' + IdMach
  );
}
function getMachineElementChilds(idMachine) {
  return axios.get(`/machinestructure/getMachineChildElements/${idMachine}`);
}
function getMachineDesc(idMachine) {
  return axios.get(`/machine/getMachineDescription/${idMachine}`);
}
function getTagMachineDescAndCount(idMachine) {
  return axios.get(`/machine/getTagMachineStatus/${idMachine}`);
}
function getGroups(IdMach) {
  //idmachine= 1 e level=1
  return axios.get('/machinestructure/structureItems?idMachine=' + IdMach);
}

function getSubgroup(id) {
  return axios.get(
    '/machinestructure/structureItemsByIdMachineOrIdFather?idFather=' + id
  );
}

function getComponent(id) {
  return axios.get(
    '/machinestructure/structureItemsByIdMachineOrIdFather?idFather=' + id
  );
}

function getTipology(docType = null) {
  return axios.get('/smpintervention/items', {
    params: {
      pageSize: 1000,
      ...(docType && { docType })
    }
  });
}

function getTipologyById(id) {
  return axios.get('/smpintervention/items/' + id);
}

function getTurno() {
  return axios.get(
    '/teamshift/items?filter=%20Id>0%20&orderBy=Id%20&pageSize=1000'
  );
}

//ASSIGN EWO
function getEWOs() {
  return axios.get('/docewo/items');
}
function getRootCauseEWOs() {
  return axios.get('/docewo/itemsRootCause');
}

function getEWOassign(pageIndex, pageSize, sorting) {
  if (sorting == undefined || sorting == '') {
    sorting = 'datecreation desc';
  }
  if (pageIndex == undefined) {
    pageIndex = 0;
  }
  if (pageSize == undefined) {
    pageSize = 1000;
  }
  return axios.get(
    `/docewo/itemsv2?pageIndex=${pageIndex}&pageSize=${pageSize}&orderBy=${sorting}`
  );
}

function getApprovedEwo(pageIndex, pageSize, sorting, docType) {
  if (sorting == undefined || sorting == '') {
    sorting = 'datecreation desc';
  }
  if (pageIndex == undefined) {
    pageIndex = 0;
  }
  if (pageSize == undefined) {
    pageSize = 1000;
  }
  return axios.get(
    `/docewo/approvedItems?pageIndex=${pageIndex}&pageSize=${pageSize}&orderBy=${sorting}&docType=${docType}`
  );
}
function getEWOassignOper(pageIndex, pageSize, sorting) {
  if (sorting == undefined || sorting == '') {
    sorting = 'datecreation desc';
  }
  if (pageIndex == undefined) {
    pageIndex = 0;
  }
  if (pageSize == undefined) {
    pageSize = 1000;
  }
  return axios.get(
    `/docewo/itemsv2Oper?pageIndex=${pageIndex}&pageSize=${pageSize}&orderBy=${sorting}`
  );
}
function getEWOEmail(filter) {
  const sqlFilter = `Id=${filter}`;
  return axios.get(
    `/docewo/itemsEmail?filter=${encodeURIComponent(sqlFilter)}`
  );
}
function getEWOClosed(pageIndex, pageSize, sorting) {
  if (sorting == undefined || sorting == '') {
    sorting = 'datecreation desc';
  }
  return axios.get(
    `/docewo/itemsClosed?pageIndex=${pageIndex}&pageSize=${pageSize}&orderBy=${sorting}`
  );
}

function getEWOsClosedByDates(values, pageIndex, pageSize) {
  if (pageIndex == undefined) {
    pageIndex = 0;
  }
  if (pageSize == undefined) {
    pageSize = 1000;
  }
  if (values.Date1 && values.Date2) {
    return axios.get(
      `/docewo/itemsClosedByDates?pageIndex=${pageIndex}&pageSize=${pageSize}&data1=${values.DateStartEwo}&data2=${values.DateEndEwo}&data3=${values.Date1}&data4=${values.Date2}`
    );
  } else {
    return axios.get(
      `/docewo/itemsClosedByDates?pageIndex=${pageIndex}&pageSize=${pageSize}&data1=${values.DateStartEwo}&data2=${values.DateEndEwo}`
    );
  }
}
function getEwoByAdvancedFiltersClosed(
  values,
  pageIndex,
  pageSize,
  sorting,
  tipoRicerca,
  isSap = false,
  isSendToSap = false
) {
  if (values.Date1 == null) {
    values.Date1 = '';
  }
  if (values.Date2 == null) {
    values.Date2 = '';
  }
  if (values.Datediagnostic == null) {
    values.Datediagnostic = '';
  }
  if (values.InterventionDate == null) {
    values.InterventionDate = '';
  }
  if (sorting == undefined || sorting == '') {
    sorting = 'datecreation desc';
  }
  if (tipoRicerca == undefined || tipoRicerca == '') {
    tipoRicerca = 0;
  }
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const queryString = new URLSearchParams(values).toString();
  return axios.get(
    `/docewo/itemsClosedAdvancedFiltered?${queryString}&pageIndex=${pageIndex}&pageSize=${pageSize}&orderBy=${sorting}&timeZone=${timeZone}&tipoRicerca=${tipoRicerca}&isSap=${isSap}&isSendToSap=${isSendToSap}`
  );
}
/*
function getExcelReport(pidPlant){
  return axios.get('/docewo/excelItems/' + pidPlant , {responseType: 'blob'});
}
*/
function getRootCauseReport(values) {
  if (values.DateAssign1 == null) {
    values.DateAssign1 = '';
  }
  if (values.DateAssign2 == null) {
    values.DateAssign2 = '';
  }
  const queryString = new URLSearchParams(values).toString();
  return axios.get(`/docewo/excelItemsRootCause?${queryString}`, {
    responseType: 'blob'
  });
}

function getExcelReport(
  pidPlant,
  myTimeZone,
  Date1,
  Date2,
  DateStartEwo,
  DateEndEwo
) {
  // return axios.get('/docewo/excelItemsAss/' + pidPlant , {responseType: 'blob'});
  return axios.get(
    '/docewo/excelItems?idplant=' +
    pidPlant +
    '&locTimeZone=' +
    myTimeZone +
    '&dataEwoStart=' +
    DateStartEwo +
    '&dataEwoEnd=' +
    DateEndEwo +
    '&dataEwoAssStart=' +
    Date1 +
    '&dataEwoAssEnd=' +
    Date2,
    { responseType: 'blob' }
  );
}
/*
function getExcelAssReport(pidPlant){
  return axios.get('/docewo/excelItemsAss/' + pidPlant , {responseType: 'blob'});
}
*/
function getExcelAssReport(
  pidPlant,
  myTimeZone,
  Date1,
  Date2,
  DateStartEwo,
  DateEndEwo
) {
  // return axios.get('/docewo/excelItemsAss/' + pidPlant , {responseType: 'blob'});
  return axios.get(
    '/docewo/excelItemsAss?idplant=' +
    pidPlant +
    '&locTimeZone=' +
    myTimeZone +
    '&dataEwoStart=' +
    DateStartEwo +
    '&dataEwoEnd=' +
    DateEndEwo +
    '&dataEwoAssStart=' +
    Date1 +
    '&dataEwoAssEnd=' +
    Date2,
    { responseType: 'blob' }
  );
}
function getNewExcelHistoryReport(Date1, Date2, DateStartEwo, DateEndEwo) {
  if (DateStartEwo == null) {
    DateStartEwo = '';
  }
  if (DateEndEwo == null) {
    DateEndEwo = '';
  }
  if (Date1 == null) {
    Date1 = '';
  }
  if (Date2 == null) {
    Date2 = '';
  }
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return axios.get(
    '/docewo/getNewEwoHistoryExcel?' +
    'dataEwoStart=' +
    DateStartEwo +
    '&dataEwoEnd=' +
    DateEndEwo +
    '&dataEwoAssStart=' +
    Date1 +
    '&dataEwoAssEnd=' +
    Date2 +
    '&timeZone=' +
    timeZone,
    { responseType: 'blob' }
  );
}

function sendItemToSap(request) {
  return axios.post(`/senttosap/items`, request);
}

function getNewExcelAssReport(Date1, Date2, DateStartEwo, DateEndEwo) {
  if (DateStartEwo == null) {
    DateStartEwo = '';
  }
  if (DateEndEwo == null) {
    DateEndEwo = '';
  }
  if (Date1 == null) {
    Date1 = '';
  }
  if (Date2 == null) {
    Date2 = '';
  }
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return axios.get(
    '/docewo/getNewEwoAssExcel?' +
    'dataEwoStart=' +
    DateStartEwo +
    '&dataEwoEnd=' +
    DateEndEwo +
    '&dataEwoAssStart=' +
    Date1 +
    '&dataEwoAssEnd=' +
    Date2 +
    '&timeZone=' +
    timeZone,
    { responseType: 'blob' }
  );
}

//EWO ASSEGNATE FILTRATE PER TEAM

function getEWOassigned(idteam, plantdesc = null) {
  let filter = `idteam=${idteam}%26dateclosing%3Dnull%26statedoc%3E1`;

  // Aggiungo il filtro isApproved solo se serve
  if (isPlantNewEwoFeatures(plantdesc)) {
    filter += `%26isApproved==true`;
  }

  return axios.get(`/docewo/items?filter=${filter}`);
}

//EWO CREATE FILTRATE PER UTENTE

function getEWOassignedByIduser(idPlant, idUser) {
  return axios.get(
    'docewo/itemsv2?filter=idPlant%3D' +
    idPlant +
    '%26idrespcreation%3D' +
    idUser
  );
}

function putEWO(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.put('/docewo/items', data, options);
}
function putDatesEWO(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.put('/docewo/itemsDate', data, options);
}

function ReopenEWO(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.put('/docewo/Reopenitems', data, options);
}

function getTeams() {
  return axios.get('/maintteam/getAllTeams');
}

//EWO REPORTING
function getEwoRep(id) {
  //sostituita con docewo invece di ewo reporting
  return axios.get('/doceworeporting/items/' + id);
}
function getEwoRepStoredProcedure(plantId, machineId) {
  return axios.get(
    `/doceworeporting/itemsStoredProcedure?plantId=${plantId}&machineId=${machineId}`
  );
}
function getEwoRepAllSpares() {
  return axios.get(`/doceworeporting/allSpareParts`);
}
function getEwoRepEWO(id) {
  //sostituita con docewo invece di ewo reporting
  return axios.get('/doceworeporting/items?filter=idewo' + id);
}

function postEwoRep(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.post('/doceworeporting/items', data, options);
}
function putEwoRep(data) {
  const options = {
    headers: { 'Content-Type': 'application/json' }
  };
  return axios.put('/doceworeporting/items', data, options);
}

function putImagesEwo(id, files) {
  var formData = new FormData();
  files.forEach(file => {
    formData.append('images', file);
  });
  const options = {
    headers: { 'Content-Type': 'multipart/form-data' }
  };
  return axios.put('/doceworeporting/image?id=' + id, formData, options);
}

function putEwoFile(id, files) {
  let formData = new FormData();
  files.forEach(file => {
    formData.append('files', file);
  });
  const options = {
    headers: { 'Content-Type': 'multipart/form-data' }
  };
  return axios.put(`/doceworeporting/file?id=${id}`, formData, options);
}

function getCustmFields(id) {
  return axios.get('/doceworeporting/itemsCustom/' + id);
}

function getdescriptionList(id) {
  return axios.get('/doceworeporting/descriptionList/');
}

function getEwoByDatesFilter(values, pageIndex, pageSize) {
  if (pageIndex == undefined) {
    pageIndex = 0;
  }
  if (pageSize == undefined) {
    pageSize = 1000;
  }
  if (values.Date1 && values.Date2) {
    return axios.get(
      `/docewo/itemsByDates?pageIndex=${pageIndex}&pageSize=${pageSize}&data1=${values.DateStartEwo}&data2=${values.DateEndEwo}&data3=${values.Date1}&data4=${values.Date2}`
    );
  } else {
    return axios.get(
      `/docewo/itemsByDates?pageIndex=${pageIndex}&pageSize=${pageSize}&data1=${values.DateStartEwo}&data2=${values.DateEndEwo}`
    );
  }
}
function getEwoByAdvancedFilters(
  values,
  pageIndex,
  pageSize,
  sorting,
  tipoRicerca
) {
  if (values.Date1 == null) {
    values.Date1 = '';
  }
  if (values.Date2 == null) {
    values.Date2 = '';
  }
  if (sorting == undefined || sorting == '') {
    sorting = 'datecreation desc';
  }
  if (tipoRicerca == undefined || tipoRicerca == '') {
    tipoRicerca = 0;
  }
  console.log('tipoRicercaDataEwo', tipoRicerca);
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const filterValues = { ...values };

  let states = [];
  if (filterValues.State) {
    states = Array.isArray(filterValues.State) ? filterValues.State : filterValues.State.toString().split(',');
  }

  const stateStrings = states.map(s => s.toString());

  if (stateStrings.includes('onhold')) {
    filterValues.Onhold = true;
    states = states.filter(s => s.toString() !== 'onhold');
  }

  filterValues.State = states.join(',');

  if (filterValues.Onhold === null || filterValues.Onhold === undefined) {
    delete filterValues.Onhold;
  }

  const queryString = new URLSearchParams(filterValues).toString();
  return axios.get(
    `/docewo/itemsByAdvancedFilters?${queryString}&pageIndex=${pageIndex}&pageSize=${pageSize}&orderBy=${sorting}&timeZone=${timeZone}&tipoRicerca=${tipoRicerca}`
  );
}

function getEWOsByDateCreation(data1, data2) {
  return axios.get(
    '/docewo/itemsByDateCreation?data1=' + data1 + '&data2=' + data2
  );
}
function getEWOsByDateAssignement(data1, data2) {
  return axios.get(
    '/docewo/itemsByDateAssignement?data1=' + data1 + '&data2=' + data2
  );
}

function itemsRootCauseByDateAssignement(data1, data2) {
  return axios.get(
    '/docewo/itemsRootCauseByDateAssignement?date1=' + data1 + '&date2=' + data2
  );
}
function getEWOsClosedByDateCreation(data1, data2) {
  return axios.get(
    '/docewo/itemsClosedByDateCreation?data1=' + data1 + '&data2=' + data2
  );
}
function getEWOsClosedByDateCreationAndTeam(data1, data2, idteam) {
  if (idteam != null)
    return axios.get(
      '/docewo/itemsClosedByDateCreationAndTeam?data1=' +
      data1 +
      '&data2=' +
      data2 +
      '&idteam=' +
      idteam
    );
  else
    return axios.get(
      '/docewo/itemsClosedByDateCreation?data1=' + data1 + '&data2=' + data2
    );
}
function getEWOsByUoMachine(uo, mac, pageIndex, pageSize) {
  return axios.get(
    '/docewo/itemsByUoMachine?uo=' +
    uo +
    '&mac=' +
    mac +
    '&pageIndex=' +
    pageIndex +
    '&pageSize=' +
    pageSize
  );
}

function getEWOsByDateClosing(data1, data2) {
  return axios.get(
    '/docewo/itemsByDateClosing?data1=' + data1 + '&data2=' + data2
  );
}
//TAG

function getOperators(idteam) {
  return axios.get('/maintteam/items/' + idteam);
}

function getEwoCostTypes(docType) {
  return axios.get('/docewo/getEwoCostTypes', {
    params: {
      docType: docType
    }
  });
}

function getEwoNewFields(id) {
  return axios.get(`/docewo/getEwoNewFields/${id}`);
}
function getLmraPdfReport(data) {
  return axios.post(`/docewo/getLmraPdfReport`, data, { responseType: 'blob' });
}

function getLmraTestEwo() {
  return axios.get(`/docewo/getLmraTestEwo`, { responseType: 'blob' });
}

function deleteEwo(id) {
  return axios.delete('/docewo/items/' + id);
}

export {
  getLmraPdfReport,
  getLmraTestEwo,
  getEwo,
  getGroup,
  getTipology,
  getTipologyById,
  getTurno,
  getSubgroup,
  getComponent,
  postEwo,
  getEWOs,
  getEWOassign,
  getTeams,
  putEWO,
  getEwoRep,
  postEwoRep,
  putEwoRep,
  putImagesEwo,
  getEWOassigned,
  putEwoFile,
  getEwoRepEWO,
  getEwoRepAllSpares,
  updateOnHold,
  getGroups,
  postDuplicateItem,
  getCustmFields,
  getEwosOpen,
  getEWOsByDateCreation,
  getEWOsByDateAssignement,
  getEWOassignedByIduser,
  getEWOClosed,
  getEWOsByDateClosing,
  getEWOsByUoMachine,
  getEWOsClosedByDateCreation,
  getEWOsClosedByDateCreationAndTeam,
  updateInCarico,
  getdescriptionList,
  getEwoIntervention,
  ReopenEWO,
  getExcelReport,
  getExcelAssReport,
  getNewExcelAssReport,
  getEwoByDatesFilter,
  getEwoByAdvancedFilters,
  getEWOsClosedByDates,
  getEwoByAdvancedFiltersClosed,
  getEwoRepStoredProcedure,
  getMachineCode,
  getMachineId,
  getEWOEmail,
  putDatesEWO,
  getEWOassignOper,
  getBreakdowns,
  getOperators,
  postFile,
  getRootCauseReport,
  getRootCauseEWOs,
  itemsRootCauseByDateAssignement,
  getMachineElementChilds,
  getMachineDesc,
  getEwoCostTypes,
  postEwoAttachments,
  getEwoNewFields,
  getNewExcelHistoryReport,
  getTagMachineDescAndCount,
  getItemDetailsById,
  sendItemToSap,
  deleteEwo,
  getApprovedEwo
};
